import { ButtonIcon } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

type RecordAudioButtonProps = {
  disabled: boolean;
  onClick: () => void;
};

export const ChatFormRecordAudioButton = ({
  disabled,
  onClick,
}: RecordAudioButtonProps) => {
  return (
    <Flex>
      <ButtonIcon
        aria-label="record audio button"
        style={{
          backgroundColor: 'var(--bgPrimary)',
        }}
        disabled={disabled}
        data-testid="chat-record-audio"
        onClick={onClick}
        size="md"
      >
        <Icon
          name={iconNames.mic}
          fill="var(--fgSecondary)"
          hoverFill="var(--fgInteractive)"
          height="24px"
          width="24px"
        />
      </ButtonIcon>
    </Flex>
  );
};
